import React from 'react';
import { LoadingButton } from '@mui/lab';
import Button from '@material-ui/core/Button';
import BloomCheckQuestionCounter from './BloomCheckQuestionCounter';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';


export default function CustomizedDialogs(props) {
  const userObj = useSelector(state => state.userDetails);
  const childRefQuestionCounter = React.useRef();
  const [topicQuestionCountList, setTopicQuestionCountList] = React.useState([]);
  const [checkCountLoadingFlag, setCheckCountLoadingFlag] = React.useState(false);

  function checkAvailability(){
    	if(!props.topicId){
        return false;
      }	
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 			
      
      let qryStr="?topicId="+props.topicId+"&examType="+props.examType;

      if(props.treeviewTemplateId && props.treeviewTemplateId>0){
        qryStr+="&treeviewTemplateId="+props.treeviewTemplateId;
      }
      if(props.searchRecursively && props.searchRecursively===true){
        qryStr+="&searchRecursively=1";
      }else{
        qryStr+="&searchRecursively=0"; 
      }      
      if(props.difficultyIds && props.difficultyIds.length>0 && props.difficultyIds!=="0"){
        qryStr+="&difficultyIds="+props.difficultyIds;
      }
      if(props.gradeId && props.gradeId>0){
        qryStr+="&gradeId="+props.gradeId;
      }
      if(props.questionTypeIds && props.questionTypeIds.length>0 && props.questionTypeIds!=="0"){
        qryStr+="&questionTypeIds="+props.questionTypeIds;
      }
      setCheckCountLoadingFlag(true);
      axios.get(env.API_URL+"/exams/read/topics-bloom-question-count"+qryStr, axiosHeader) 
			   .then(response => {
          setCheckCountLoadingFlag(false);
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="success"){		
          //document.writeln(JSON.stringify(response.data.obj));		

          if(response.data.obj){
					  setTopicQuestionCountList(response.data.obj);
          }

          childRefQuestionCounter.current.handleClickOpen();
				}		
			}).catch((error) => {
				alert("ERROR: ", error);
			})	

  }

  

  return (
    <>
     {checkCountLoadingFlag?
      <LoadingButton loading={checkCountLoadingFlag} loadingPosition='start' startIcon={<div style={{marginRight:15}}></div>} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Counting...</LoadingButton>
     :<Button onClick={() => {checkAvailability()}} size="small" variant={props.variant} >Bloom Counter</Button>
     }
    <BloomCheckQuestionCounter topicName={props.topicName} topicQuestionCountList={topicQuestionCountList} ref={childRefQuestionCounter} />
    </>
  );
}
